import React, { useEffect } from 'react'
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { Typography } from '@mui/material';

const ChangeLogSubTypeFilter = ({list, onClickSubTypeList,isFilterDisabled}) => {
    const [value, setValue] = React.useState('');
    const handleChange = (val,label) => {
        setValue(val);
        onClickSubTypeList(label);
    };

    useEffect(() => {
        if(isFilterDisabled || list){
            setValue('');
        }
    },[isFilterDisabled,list])

    return (
        <>
        <Box 
            className=""
            sx={{
                marginBottom: 2,
                paddingBottom: '5px',
                overflowX: 'auto',
                "&::-webkit-scrollbar": {
                    height: '4px',
                    width: '4px',
                    background: 'gray',
                },
                "&::-webkit-scrollbar-track": {
                    background: '#f1f1f1'
                },
                "&::-webkit-scrollbar-thumb": {
                    background: '#888'
                },
                "&::-webkit-scrollbar-thumb:hover": {
                    background: 'rgb(30,60,114)'
                },
                "&::-webkit-scrollbar-thumb:horizontal": {
                    borderRadius: '10px'
                },
      
            }}
        >
            <Typography sx={{paddingBottom:1,color:'rgba(0, 0, 0, 0.6)'}}>Change Log Sub Type:</Typography>
            <Stack direction="row" spacing={2}>
            {list?.data?.map((row, i) => (
                <Chip disabled={isFilterDisabled} key={row.id}  className={value === row.id && !isFilterDisabled ? 'filterActive' : ''}  label={row.name} onClick={(e) => handleChange(row.id,row.label)} />
            ))}
            </Stack>
        </Box>
        </>
    )
}

export default ChangeLogSubTypeFilter